<template>
  <div>
    <div class="newsAll" v-if="getLocaltypes()==1">
    <div class="news">

      <div class="headimage">
        <div class="headfont">
          <h2>新闻</h2>
        </div>
        <img src="static/saw_campus.jpg">
      </div>

      <div class="contain">
        <h2>动态</h2>
      </div>


      <div class="newslist">
        <div class="contains">
          <!-- <div class="leftimage"><img src="https://www.xjtlu.edu.cn/zh/news//zh/assets/image-cache/images/news/2022/07/group_ilead.2c28fede.jpg"></div> -->

          <div class="post" @click="getNews(Dynamic)" v-for="(Dynamic,index) in DynamicList" :key="index">
            <div class="imagess"> <img :src="imagepath+Dynamic.news_FILE_PATH" alt="加载失败"></div>
            <div class="info"><time :datetime="Dynamic.newsTime"><span class="span2">{{Dynamic.newsTime |
                  formatTimer}}</span></time></div>
            <div class="">
              <span class="span3">{{Dynamic.news_TITLE}}</span>
            </div>
            <hr class="hr" />
          </div>


        </div>
        <div class="morecontain">
          <span class="span4">
            <router-link :to="{path:'/ViewAllNews', query:{ news_type: '动态' }}">浏览全部动态</router-link>
          </span>
        </div>
      </div>
      <div class="contain">
        <h2>快讯</h2>
      </div>
      <div class="newslist">
        <div class="contains">
          <!-- <div class="leftimage"><img src="https://www.xjtlu.edu.cn/zh/news//zh/assets/image-cache/images/news/2022/07/group_ilead.2c28fede.jpg"></div> -->

          <div class="post" @click="getNews(Flash)" v-for="(Flash,index) in FlashList" :key="index">
            <div class="imagess"> <img :src="imagepath+Flash.news_FILE_PATH" alt="加载失败"></div>
            <div class="info"><time :datetime="Flash.newsTime"><span class="span2">{{Flash.newsTime |
                  formatTimer}}</span></time></div>
            <div class="">
              <span class="span3">{{Flash.news_TITLE}}</span>
            </div>
            <hr class="hr">
          </div>
        </div>
        <div class="morecontain">
          <span class="span4">
            <router-link :to="{path:'/ViewAllNews', query:{ news_type: '快讯' }}">浏览全部快讯</router-link>
          </span>
        </div>

      </div>
      <div class="contain">
        <h2>深度</h2>
      </div>
      <div class="newslist">
        <div class="contains">
          <!-- <div class="leftimage"><img src="https://www.xjtlu.edu.cn/zh/news//zh/assets/image-cache/images/news/2022/07/group_ilead.2c28fede.jpg"></div> -->

          <div class="post" @click="getNews(Depth)" v-for="(Depth,index) in DepthList" :key="index">
            <div class="imagess"> <img :src="imagepath+Depth.news_FILE_PATH" alt="加载失败"></div>
            <div class="info"><time :datetime="Depth.newsTime"><span class="span2">{{Depth.newsTime |
                  formatTimer}}</span></time></div>
            <div class="">
              <span class="span3">{{Depth.news_TITLE}}</span>
            </div>
            <hr class="hr">
          </div>
        </div>
        <div class="morecontain">
          <span class="span4">
            <router-link :to="{path:'/ViewAllNews', query:{ news_type: '深度' }}">浏览全部深度</router-link>
          </span>
        </div>

      </div>
    </div>
  </div>
  <div v-if="getLocaltypes()==2">
    <div>
          <h1 style="line-height: 100%; text-align: center;">新闻</h1>
      </div>

      <div style="margin-top: 30px;">
        <h3>动态</h3>
      </div>


      <div class="newslist2">
        <div class="contains2">
          <!-- <div class="leftimage"><img src="https://www.xjtlu.edu.cn/zh/news//zh/assets/image-cache/images/news/2022/07/group_ilead.2c28fede.jpg"></div> -->

          <div class="post2" @click="getNews(Dynamic)" v-for="(Dynamic,index) in DynamicList" :key="index">
            <div class="imagess"> <img :src="imagepath+Dynamic.news_FILE_PATH" alt="加载失败"></div>
            <div class="info"><time :datetime="Dynamic.newsTime"><span class="span2">{{Dynamic.newsTime |
                  formatTimer}}</span></time></div>
            <div class="">
              <span class="span3">{{Dynamic.news_TITLE}}</span>
            </div>
            <hr class="hr" />
          </div>


        </div>
        <div class="morecontain2">
          <span class="span4">
            <router-link :to="{path:'/ViewAllNews', query:{ news_type: '动态' }}">浏览全部动态</router-link>
          </span>
        </div>
      </div>
      <div class="contain" style="margin-top: 30px;">
        <h3>快讯</h3>
      </div>
      <div class="newslist2">
        <div class="contains2">
          <!-- <div class="leftimage"><img src="https://www.xjtlu.edu.cn/zh/news//zh/assets/image-cache/images/news/2022/07/group_ilead.2c28fede.jpg"></div> -->

          <div class="post2" @click="getNews(Flash)" v-for="(Flash,index) in FlashList" :key="index">
            <div class="imagess"> <img :src="imagepath+Flash.news_FILE_PATH" alt="加载失败"></div>
            <div class="info"><time :datetime="Flash.newsTime"><span class="span2">{{Flash.newsTime |
                  formatTimer}}</span></time></div>
            <div class="">
              <span class="span3">{{Flash.news_TITLE}}</span>
            </div>
            <hr class="hr">
          </div>
        </div>
        <div class="morecontain2">
          <span class="span4">
            <router-link :to="{path:'/ViewAllNews', query:{ news_type: '快讯' }}">浏览全部快讯</router-link>
          </span>
        </div>

      </div>
      <div>
        <h3>深度</h3>
      </div>
      <div class="newslist2">
        <div class="contains2">
          <!-- <div class="leftimage"><img src="https://www.xjtlu.edu.cn/zh/news//zh/assets/image-cache/images/news/2022/07/group_ilead.2c28fede.jpg"></div> -->

          <div class="post2" @click="getNews(Depth)" v-for="(Depth,index) in DepthList" :key="index">
            <div class="imagess"> <img :src="imagepath+Depth.news_FILE_PATH" alt="加载失败"></div>
            <div class="info"><time :datetime="Depth.newsTime"><span class="span2">{{Depth.newsTime |
                  formatTimer}}</span></time></div>
            <div class="">
              <span class="span3">{{Depth.news_TITLE}}</span>
            </div>
            <hr class="hr">
          </div>
        </div>
        <div class="morecontain2">
          <span class="span4">
            <router-link :to="{path:'/ViewAllNews', query:{ news_type: '深度' }}">浏览全部深度</router-link>
          </span>
        </div>
        <div style="height: 50px;"></div>
      </div>
  </div>
  </div>

</template>

<script>
import {getLocaltype} from '../mainConfig/thu'
export default {
  data(){
    return{
      appName:'',
    DynamicList:[],
    FlashList:[],
    DepthList:[],
    imagepath:''
    }
  },
   created(){
    this.imagepath=this.$imagepath
    this.getNewBytype()
   },
   filters: {
        formatTimer: function(value) {
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? "0" + MM : MM;
          let d = date.getDate();
          d = d < 10 ? "0" + d : d;
          let h = date.getHours();
          h = h < 10 ? "0" + h : h;
          let m = date.getMinutes();
          m = m < 10 ? "0" + m : m;
          let s = date.getSeconds();
          s = s < 10 ? "0" + s : s;
          // return y + "-" + MM + "-" + d + " " + h + ":" + m;
          return y + "年" + MM + "月" + d ;
        }
      },
   methods:{
    getNewBytype(){
       this.axios.post("/news/getNewBytype")
    .then(resp => { 
                       if(resp.data.status == 1) {
                                    this.DynamicList=resp.data.result.Dynamic;
                                     this.FlashList=resp.data.result.Flash;
                                     this.DepthList=resp.data.result.Depth;
                                    console.log(resp.data.result)//动态
                                }else {
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
    },getLocaltypes(){
  return getLocaltype();
},getNews(data){
      this.$router.push({  //核心语句
        path:'/news',   //跳转的路径
        query:{           //路由传参时push和query搭配使用 ，作用时传递参数
          newsid:data.newsid,
          newsHtmlURL:data.newsFilePath
        }
      })
    }
   }

}
</script>

<style scoped >
.headimage{
  width: 1110.91px;
  height: 398.79px;
  margin: auto;
    padding: 0;
    border: none;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    color: #333;
    /* background-image: url('https://www.xjtlu.edu.cn/zh/news/zh/assets/image-cache/images/campus/campus005.1f5be76d.jpg'); */
    background-size: 100% 100%;
    background-image: linear-gradient(45deg, rgba(1, 5, 68, 0.7) 8%, rgba(37, 255, 249, 0));
}
.headimage2{
  width: 100%;
  height: 200;

    padding: 0;
    margin: 0%;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    color: #333;
    background-size: 100% 100%;
    background-image: linear-gradient(45deg, rgba(1, 5, 68, 0.7) 8%, rgba(37, 255, 249, 0));
}
h2{
  font-weight: 500;
    font-size:50px ;
    color: #fff;
    
}
.headfont{
  padding-top: 230px;
  padding-left: 50px;
  position: absolute;
}
.newsAll{
background: #F4F4F4;
display: block;
}
.news{
  width: 1110.91px;
  margin: auto;
  background-color: #FFFFFF;
}
.el-breadcrumb {
    margin-top: 40px;
}
.news-lead{
  padding-bottom: 0px;
  width: 1000px;
  height: 55px;

  margin-top: 10px;
}
li{
  color: rgba(1, 5, 68, 0.95);
  float: left;
  margin-left: 4%;
  list-style:none;
 font-weight: bold;
  
}
nav {
    float: left;
    width: 100%;
}
a{
  color: rgba(1, 5, 68, 0.95);
  text-decoration:none;
}
.left-right-path{
      background-color: #FFFFFF;
      height: 480px;
      margin-top: 15px;
}
.block-content{
  width: 1000px;
  height: 400px;
  
  margin: auto;
}
.content{
  width: 350px;
  height: 400px;
 background-color: #3D3B46;
  float: left;
}
.content h2{
  font-weight: bold;
  font-size: 30px;
  line-height: 1.2;
  margin-bottom: 10px;
  text-transform: uppercase;
  position: relative;
  padding: 13px;
}
.image{
  width: 650px;
  height: 400px;
  float: right;
  background-image: url(http://saw.wxu.edu.cn/r/cms/sglxy/sglxy/images/sydt/2.jpg);
}
.times{
  padding: 13px;
  color: #fff;
}
.catMore{
  margin-top: 100px;
  margin-left: 30px;
}
.catMore a{
  color: #fff;
  font-size: 15px;  
}
.contain h2{
font-weight: bold;
font-size: 30px;
line-height: 1.2;
color: #333;
margin: auto;
width: 1000px;
}

/* h2:before {
    content: '';
    background-color: #181818;
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 5px;
} */
.newslist{
  width: 1111px;
  height: 404px;

  margin-top: 40px;
}
.newslist2{
  width: 100%;


 
}
.contains{
  width: 1000px;
  height: 325.1px;
  margin: auto;
 display: flex;
justify-content: space-evenly;

}
.contains2{
  width: 100%;





}
.leftimage{
  width: 489.35px;
  height: 281.86px;
  float: left;
}
.post{
  width: 235.1px;
  height:281.86px;
  cursor: pointer;
   float: left;
  position: relative;
}
.post2{
  width: 100%;
  margin-top: 20px;
}
img{
  overflow:hidden;
  width: 100%;
  height: 100%;
}
.post imagess{
  width: 235.1px;
  height: 135.41px;

}
.post img{
  height: 135.41px;
}
.post info{
  width: 235px;
  height: 10px;
}
.span2{
  font-size: 16px;
  padding: 10px 2px;
  color: grey;
  margin-bottom: 20px;
  /* font-weight: bold; */
}
.span3{
   font-size: 16px;
  line-height: 22px;
    position: relative;
    z-index: 2;
    margin-top: 15px;
    /* font-weight: bold; */
}
.hr{
 
position: absolute;
width: 231.1px;
bottom: 0;
border: solid black;


}
.morecontain{
  clear: both; 
  margin-left: 55px;
}
.morecontain2{
  clear: both; 
  margin-top: 20px;
}
.span4{
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/work/NewsAll.vue